import { useEffect } from 'react'
import { type IResponseIntegrationRefreshed } from 'entities/Integrations'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'

type IHandlerEvent = (data: IResponseIntegrationRefreshed) => void

export const useEventIntegrationUsersRefreshed = (handler: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  useEffect(() => websocket.on(WebsocketEvent.IntegrationUsersRefreshed, handler), [])
}
